import React, { useCallback } from 'react';
import Box from '@mui/material/Box';

import DownloadApple from '../assets/download-apple.png';
import DownloadGoogle from '../assets/download-google.png';
import { APP_STORE_LINKS } from '../constants/appStoreLinks';

const badgeSx = {
  width: { xs: 132, sm: 152 },
  height: 'auto',
  maxHeight: 52,
  objectFit: 'contain',
  display: 'block',
  borderRadius: 1,
  cursor: 'pointer',
  flexShrink: 0,
  transition: 'opacity 0.15s ease',
  '&:hover': { opacity: 0.88 },
};

function StoreBadge({ src, alt, url, onOpen }) {
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onOpen(url);
    }
  };

  return (
    <Box
      component="img"
      src={src}
      alt={alt}
      sx={badgeSx}
      onClick={() => onOpen(url)}
      role="link"
      tabIndex={0}
      onKeyDown={handleKeyDown}
    />
  );
}

export default function AppStoreBadges({ sx }) {
  const openUrl = useCallback((url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: { xs: 1.25, sm: 1.75 },
        flexWrap: 'wrap',
        width: '100%',
        ...sx,
      }}
    >
      <StoreBadge
        src={DownloadGoogle}
        alt="Get it on Google Play"
        url={APP_STORE_LINKS.android}
        onOpen={openUrl}
      />
      <StoreBadge
        src={DownloadApple}
        alt="Download on the App Store"
        url={APP_STORE_LINKS.ios}
        onOpen={openUrl}
      />
    </Box>
  );
}
